var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExcelMono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 1.6 17.2 0H5.6a1 1 0 0 0-1.2 1.1v4.4h1.7V2q0-.4.3-.4h8.3q.3 0 .3.2v5.8h5.8q.4 0 .4.3V22q0 .4-.3.4H6.4a.3.3 0 0 1-.3-.4v-1.3H4.4v2q0 1.3 1.2 1.3h16q1.3-.2 1.2-1.2V6.2l-.4-.4zm-2 .2.5.5 3 3.5.3.2h-3.2l-.5-.1-.1-.4zm-1.3 11h5.5v1.6h-5.5zm0-3.2h5.5v1.6h-5.5zm0 6.4h5.5v1.6h-5.5zM1.2 6.8v12.8h12.6V6.8zm6.3 7.4-.8 1.2h.8v1.4H3.6l2.8-4.2L4 8.8H6L7.5 11l1.4-2.2H11l-2.5 3.8 2.8 4.2H9.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExcelMono);
export default ForwardRef;